export enum TicketSlaResolutionTimeStatusEnum{
  OK="OK",
  WARNING="WARNING",
  EXCEEDED="EXCEEDED"
}
